const server_configuration = {
  "localdevelopment": {
    "address": "https://computablepublishing.com",
    "computablepublishing_website_address": "http://localhost:3001",
    "node_server_address": "http://localhost:3024/",
    "fevir_website_address": "http://localhost:3000",
    "fevir_node_server_address": "http://localhost:3104/",
    "fevir_go_server_address": "http://localhost:3107/",
    "ports": {
      "master_server": 3024,
      "fevir_master_server": 3104
    }
  },
  "development": {
    "address": "https://computablepublishing.com",
    "computablepublishing_website_address": "https://computablepublishing.com",
    "node_server_address": "https://computablepublishing.com/nodeserver/",
    "go_server_address": "https://computablepublishing.com/goserver/",
    "fevir_website_address": "https://dev.fevir.net",
    "fevir_node_server_address": "https://dev.fevir.net/nodeserver/",
    "fevir_go_server_address": "https://dev.fevir.net/goserver/",
    "ports": {
      "master_server": 3024,
      "fevir_master_server": 3104
    }
  },
  "production": {
    "address": "https://computablepublishing.com",
    "computablepublishing_website_address": "https://computablepublishing.com",
    "node_server_address": "https://computablepublishing.com/nodeserver/",
    "go_server_address": "https://computablepublishing.com/goserver/",
    "fevir_website_address": "https://fevir.net",
    "fevir_node_server_address": "https://fevir.net/nodeserver/",
    "fevir_go_server_address": "https://fevir.net/goserver/",
    "ports": {
      "master_server": 3024,
      "fevir_master_server": 3004
    }
  }
};
let server_config;
if (window.location.hostname === "computablepublishing.com") {
  server_config = server_configuration["production"];
} else {
  server_config = server_configuration["production"]; //localdevelopment
}
export default server_config;